<ng-container *transloco="let t">
  @if (campaign().timeConditions?.timeConditionsType == TimeConditionsType.PERIOD) {
    <div class="details-row">
      <img ngSrc="/assets/icons/clock-Icon.svg" alt="clock icon" height="16"
           width="16">
      <div class="details-text-row">
        @if (isSingleDay()) {
          <span
            class="details-text"
            [class.light]="lightFont()">{{ t('actions.card.validOnlyOn', {date: campaign().timeConditions!.startDate! | date: 'dd MMM'}) }}</span>
        } @else {
          @if (hasHours()) {
            <span class="details-text" [class.light]="lightFont()">{{
                t('actions.card.betweenHoursStart', {
                  startTime: (campaign().timeConditions!.startTime | timeWithoutSeconds),
                  endTime: (campaign().timeConditions!.endTime | timeWithoutSeconds)
                })
              }}</span>
          }
          @if (campaign().isActive) {
            <span class="details-text"
                  [class.light]="lightFont()">{{ t('actions.card.daysLeft', {daysLeft: daysLeft()}) }}</span>
          } @else {
            @if(!hasHours()) {
              <span class="details-text" [class.light]="lightFont()">{{ t('actions.card.valid') }}</span>
            }
            <span class="details-text" [class.light]="lightFont()">
              {{
                t('actions.card.period', {
                  startDate: campaign().timeConditions!.startDate! | date: 'dd MMM',
                  endDate: campaign().timeConditions!.endDate! | date: 'dd MMM'
                })
              }}
            </span>
          }
        }
      </div>
    </div>
  }
  @if (campaign().timeConditions?.timeConditionsType == TimeConditionsType.RECURRING) {
    <div class="details-row">
      <img ngSrc="/assets/icons/clock-Icon.svg" alt="clock icon" height="16"
           width="16">
      <div class="details-text-row">
        <span class="details-text" [class.light]="lightFont()">{{ t('actions.card.every') }} {{ daysOfWeek() }}</span>
        @if (hasHours()) {
          <span class="details-text" [class.light]="lightFont()">{{
              t('actions.card.betweenHoursEnd',
                {
                  startTime: (campaign().timeConditions!.startTime | timeWithoutSeconds),
                  endTime: (campaign().timeConditions!.endTime | timeWithoutSeconds)
                })
            }}</span>
        }
      </div>
    </div>
  }
</ng-container>
